import axios from 'axios';

const get = async () => axios.get('/tokens/public-key');

export default {
  get,
};
